// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__IlQVw","saveBtn":"styles_saveBtn__1uY6W","cancelBtn":"styles_cancelBtn__0bT86","checkIcon":"styles_checkIcon__+ggJv"};